import React from 'react';
import { FlagImage } from 'react-international-phone';
import 'react-international-phone/style.css';
import Select from 'react-select';
import { useCountries } from 'hooks/useCountries';
import { CountryOption } from 'types/country';

interface CountrySelectProps {
    value?: string | null;
    onChange: (isoCode: string | null) => void;
    placeholder?: string;
    isClearable?: boolean;
    isDisabled?: boolean;
    className?: string;
}

const formatOptionLabel = (option: CountryOption) => (
    <span className="country-select__option d-flex align-items-center gap-2">
        <FlagImage iso2={option.iso2} size="20px" />
        <span>{option.label}</span>
    </span>
);

const CountrySelect: React.FC<CountrySelectProps> = ({
    value,
    onChange,
    placeholder = 'Select country',
    isClearable = true,
    isDisabled = false,
    className,
}) => {
    const { countries, loading } = useCountries();
    const selected = countries.find((country) => country.value === (value || '').toUpperCase()) ?? null;

    return (
        <Select<CountryOption>
            className={className}
            classNamePrefix="country-select"
            options={countries}
            value={selected}
            onChange={(option: CountryOption | null) => onChange(option?.value ?? null)}
            placeholder={placeholder}
            isClearable={isClearable}
            isDisabled={isDisabled}
            isLoading={loading}
            isSearchable
            formatOptionLabel={formatOptionLabel}
            getOptionValue={(option: CountryOption) => option.value}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
            menuPosition="fixed"
            styles={{
                menuPortal: (base: React.CSSProperties) => ({ ...base, zIndex: 2000 }),
            }}
            noOptionsMessage={() => (loading ? 'Loading countries...' : 'No countries found')}
        />
    );
};

export default CountrySelect;
